// router.js - Production Version
import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            redirect: '/suche'
        },
        {
            path: '/suche',
            name: 'suche',
            component: () => import('./views/MainSuche.vue')
        },
        {
            path: '/login',
            name: 'login',
            component: () => import('./components/Auth/Login.vue')
        },
        {
            path: '/not-authorized',
            name: 'not-authorized',
            component: () => import('./components/Auth/NotAuthorized.vue')
        },
        {
            path: '/verfahren',
            name: 'Verfahren',
            component: () => import('@/components/Verfahren/VerfahrenList')
        },
        {
            path: '/standort',
            name: 'Standort',
            component: () => import('@/components/Standort/StandortList')
        },
        {
            path: '/papierkorb',
            name: 'Papierkorb',
            component: () => import('@/components/Papierkorb/PapierkorbList')
        },
        {
            path: '/lieferschein',
            name: 'Lieferschein',
            component: () => import('@/views/Shipping/MainShippingView'),
            children: [
                {
                    path: 'create',
                    name: 'LieferscheinErstellen',
                    component: () => import('@/views/Shipping/ShippingCreateView')
                },
                {
                    path: 'list',
                    name: 'LieferscheinListe',
                    component: () => import('@/views/Shipping/ShippingListView')
                }
            ]
        },
        {
            path: '/lieferschein/:id',
            name: 'LieferscheinAnzeigen',
            component: () => import('@/views/Shipping/ShippingSingleView'),
            props: route => ({ id: Number(route.params.id) })
        },
        {
            path: '/klasse',
            name: 'Klasse',
            component: () => import('@/components/Klasse/KlasseList')
        },
        {
            path: '/gegenstand',
            redirect: '/suche'
        },
        {
            path: '/gegenstand/new',
            name: 'GegenstandCreate',
            component: () => import('@/components/Gegenstand/GegenstandCreate')
        },
        {
            path: '/gegenstand/:id',
            name: 'GegenstandDetailsPage',
            component: () => import('@/components/Gegenstand/Details/GegenstandDetailsPage'),
            props: true
        },
        {
            path: '/suche',
            name: 'Suche',
            component: () => import('@/views/MainSuche.vue')
        },
        {
            path: '/funktionstest',
            name: 'Funktionstest',
            component: () => import('@/components/Funktionstest/FunktionstestList')
        },
        {
            path: '/funktionstest/:id/perform',
            name: 'PerformFunktionstest',
            component: () => import('@/components/Funktionstest/PerformFunktionstest'),
            props: true
        },
        {
            path: '/funktionstest/:id/perform/:itemId',
            name: 'PerformFunktionstestForGegenstand',
            component: () => import('@/components/Funktionstest/PerformFunktionstest'),
            props: true
        }
    ]
})

// Production Router Guard - DEBUG VERSION
router.beforeEach((to, from, next) => {
    console.log('🛡️ Router Guard:', to.path, 'from:', from.path);

    // Frühe Exits für bessere Performance
    if (!router.app || !router.app.$azure) {
        console.log('🛡️ No app or azure, allowing navigation');
        next();
        return;
    }

    if (to.path === from.path) {
        next();
        return;
    }

    const azureAd = router.app.$azure;
    console.log('🛡️ Azure AD available:', !!azureAd);
    console.log('🛡️ Is logged in:', azureAd ? azureAd.isLoggedIn() : 'N/A');

    // KORRIGIERT: Ohne Optional Chaining
    if (azureAd && azureAd.isLoggedIn()) {
        if (to.path !== '/not-authorized') {
            azureAd.getUserGroups()
                .then(gr => {
                    console.log('🛡️ User groups loaded, checking permissions...');
                    if (azureAd.isInGroupSync(gr, 'taz-eq-lesen')) {
                        console.log('✅ User authorized, allowing navigation');
                        next();
                    } else {
                        console.log('❌ User not authorized');
                        next({ path: '/not-authorized', replace: true });
                    }
                })
                .catch((err) => {
                    console.log('❌ Failed to get user groups:', err);
                    next({ path: '/login', replace: true });
                });
        } else {
            next();
        }
    } else {
        if (to.path === '/login') {
            console.log('🛡️ User not logged in, allowing access to login page');
            next();
        } else {
            console.log('🛡️ User not logged in, redirecting to login');
            next({ path: '/login', replace: true });
        }
    }
});

export default router;
